module.exports = __webpack_public_path__ + "img/37.518b11d9.jpg";